export default {
  creatingUser: 'Creando usuario {name}...',
  title: 'Usuarios',
  createUser: 'Crear Usuario',
  warningTitle: 'Advertencia',
  deleteConfirmation: 'Eliminando usuario: {name}',
  deleteWarning: 'Esta acción no se puede deshacer. ¿Está seguro?',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  editUser: 'Editar Usuario',
  deleteUser: 'Eliminar Usuario',
  deleting: 'Eliminando...',
  headerFirstName: 'Nombre',
  headerLastName: 'Apellido',
  headerEmail: 'Correo electrónico',
  headerAdmin: 'Admin',
  headerManager: 'Manager',
  headerScientist: 'Científico',
  headerSupervisor: 'Supervisor',
  headerCustomizer: 'Personalizador',
  headerDomain: 'Dominio',
  headerCreated: 'Creado',
  headerActions: 'Acciones'
}
